import { CommonModule } from "@angular/common";
import { Component, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { FormisForm, MCFormValidationService } from "@maslul/common-services";
import { MCButtonComponent, MCFieldFormComponent } from "@maslul/common-components";
import { GeneralDetailsService } from "../../../../../services/pages/general-details/general-details";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { FormlyFieldConfig, FormlyModule } from "@ngx-formly/core";
import { ReactiveFormsModule } from "@angular/forms";
import { DialogModule } from 'primeng/dialog';
import cloneDeep from "clone-deep";
import { GeneralDetailsStore } from "../../../../../services/store/general-details";
import { TranslateService } from "@ngx-translate/core";
import { GeneralSkeletonComponent } from "../../components/general-skeleton/general-skeleton";
import { PageBaseComponent } from "../../../../shared/page-base";
import { FocusOnTabDirective } from "../../../../../services/shared/directives/focus-on-tab";
import { ProductsService } from "../../../../../services/pages/products/products";

@Component({
    selector: 'mi-general-details',
    imports: [CommonModule,
        MCFieldFormComponent,
        ReactiveFormsModule,
        FormlyModule,
        MCButtonComponent,
        DialogModule,
        GeneralSkeletonComponent,
        FocusOnTabDirective
    ],
    templateUrl: './general-details.html',
    styleUrl: './general-details.scss',
    standalone: true,
    encapsulation: ViewEncapsulation.None,

})
export class GeneralDetailsComponent extends PageBaseComponent implements OnInit, OnDestroy {

    formisForm: FormisForm = new FormisForm();
    subscribtion: Subscription = new Subscription();
    displaySuccessDialog: boolean = false;
    tabsText: any;
    genericText: any;

    constructor(private generalDetailsService: GeneralDetailsService
        , private generalDetailsStore: GeneralDetailsStore
        , private formValidationService: MCFormValidationService
        , public override router: Router
        , private translateService: TranslateService
        , private productService: ProductsService) {

        super(router);
    }


    ngOnInit() {
        this.initFormisForm();
        this.initText();
    }

    initText() {

        this.subscribtion.add(this.translateService.stream('generic').subscribe(translation => {
            this.genericText = translation;
        }));
        this.subscribtion.add(this.translateService.stream('tabs').subscribe(translation => {
            this.tabsText = translation;

        }));
    }


    initFormisForm() {
        this.formisForm.options = {};//formState from store
        //this.formisForm.form = new FormGroup({});
        this.formisForm.model = cloneDeep(this.generalDetailsStore.getSnapshot().formisFormModel);
        this.initFields();


    }

    initFields() {
        this.subscribtion.add(
            this.generalDetailsService.getFields(this.formisForm)
                .subscribe((formisFormFields: Array<FormlyFieldConfig> | undefined) => {
                    if (formisFormFields) {
                        this.formisForm.fields = formisFormFields;
                    }
                }))
            ;
    }


    back() {
        this.generalDetailsStore.setFormisFormModel(cloneDeep(this.formisForm.model));
        this.navigation('applicant-details')
    }


    next() {
        const isValid = this.formisForm.form.valid;

        this.generalDetailsStore.setFormisFormModel(cloneDeep(this.formisForm.model));

        if (isValid) {
            this.generalDetailsService.saveFormState(cloneDeep(this.formisForm.model));
            this.productService.nextToProductTab();

        }
        else {
            this.formisForm.form.markAllAsTouched();
            const invalidFields = this.formValidationService.getInvalidControlsFlatMap(this.formisForm.form);
            console.log('generalDetails get invalid field', invalidFields);


        }
    }


    ngOnDestroy(): void {
        this.subscribtion.unsubscribe();
    }
}